import { render } from "./Proveedores.vue?vue&type=template&id=4ee0233a&scoped=true"
import script from "./Proveedores.vue?vue&type=script&lang=js"
export * from "./Proveedores.vue?vue&type=script&lang=js"

import "./Proveedores.vue?vue&type=style&index=0&id=4ee0233a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee0233a"]])

export default __exports__